// extracted by mini-css-extract-plugin
export default {"searchForm":"SearchForm_searchForm__w8hOV","searchInput":"SearchForm_searchInput__btBBF"};